import type { LinkGroups } from "@/pages/clientWidgets/types";
import { Links } from "./widgetFooter/Links";

type Props = {
	links?: LinkGroups;
};

export function WidgetFooter({ links }: Props): React.ReactNode {
	return (
		<div className="widgetfooter">
			<Links links={links} />
		</div>
	);
}
